import RagnaModal from '../ReactComponents/RagnaModal';
import RagnaLoader from '../ReactComponents/RagnaLoader';
import { useState } from 'react';
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import Cookies from 'universal-cookie';
import { useEffect } from 'react';
import axios from 'axios';
import { ajax_api } from '../../Globals';

const AuthBox = props => {
    const cookies = new Cookies();
    const [resetMode, setResetMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState();
    const [notif, setNotif] = useState();
    const { getValues: getValsLogin, setFocus, register, handleSubmit, reset, formState: { errors:errorsLogin } } = useForm();
    const { watch, setFocus: setFocusRes, register: regCPass, handleSubmit: handleSubmitCPass, reset: resetCPass, formState: { errors:errorsCPass } } = useForm();

    const processData = d => {
        var f = new FormData();
        setErrors();
        setLoading(true);
        setNotif();

        if (resetMode) {
            //change pass here
            f.append("username", d.username);
            f.append("oldPassword", d.password);
            f.append("newPassword", d.newPassword);
            axios.post("http://172.16.100.9/CGPP-CDS/api/external/reset", f).then(_ => { //ajax_api + "auth/reset"
                setResetMode(false);
                setNotif("You have successfully changed your password! You may now login.");
                reset({
                    username: d.username,
                    password: "",
                })
                setFocus("password");
            }).catch(e => {
                setErrors(e.response.data);
            }).finally(_ => setLoading(false));
        } else {
            f.append("username", d.username);
            f.append("password", d.password);
            axios.post(ajax_api + "auth/login", f, { withCredentials: true }).then(r => {
                if (r.data.reset) {
                    //for reset password
                    setResetMode(true);
                    setNotif("Change your password to complete password reset.");
                    resetCPass({
                        username: d.username,
                        password: d.password,
                    })
                    setFocus("password");
                } else {
                    props.setCreds(r.data)
                    cookies.set('creds', r.data, { path: '/' });
                    reset();
                    resetCPass();
                    props.setModalOpen(false);
                }

            }).catch(e => {
                setErrors(e.response.data);
            }).finally(_ => setLoading(false));
        }
    }

    useEffect(_ => {
        if (props.modalOpen) setFocus("username");
    }, [props.modalOpen])

    useEffect(_ => {
        if (resetMode)
            setFocusRes("newPassword");
        else
            setFocus("password");
    },[resetMode])

    return <RagnaModal
        boxStyle={{ minHeight: 0 }}
        hideClose={loading}
        noBackdropClose={loading || resetMode}
        closeAndThen={_ => {
            setResetMode(false);
            reset();
            resetCPass();
            setNotif();
            setErrors();
        }}
        noBtn={true}
        modalOpen={props.modalOpen}
        setModalOpen={props.setModalOpen}
        title={loading?"Please wait":(resetMode?"Change Password":"Login")}
        body={
            loading ? <RagnaLoader text={resetMode ? "Changing Password" : "Logging in"} /> :
                <div>
                    {
                        notif ?
                            <div className="alert alert-success">
                                {notif}
                            </div>
                            : ""
                    }
                    {
                        errors ?
                            <div className="alert alert-warning">
                                <ul className="mb-0">
                                    {errors.map(er => <li>{er}</li>)}
                                </ul>
                            </div>
                            : ""
                    }
                    {
                        resetMode ? <form onSubmit={handleSubmitCPass(processData)}>
                            Login ID
                            <input autoComplete="off" className="form-control" {...regCPass("username", { required: "This field is required" })} />
                            <ErrorMessage errors={errorsCPass} name="username"
                                render={({ message }) => <p className="text-danger">{message}</p>} />
                            Old Password
                            <input autoComplete="off" type="password" className="form-control" {...regCPass("password", { required: "This field is required" })} />
                            <ErrorMessage errors={errorsCPass} name="password"
                                render={({ message }) => <p className="text-danger">{message}</p>} />
                            New Password
                            <input autoComplete="off" type="password" className="form-control" {...regCPass("newPassword", {
                                required: "This field is required",
                                minLength: {
                                    value: 8,
                                    message: "Minimum of 8 characters for password"
                                },
                                pattern: {
                                    value: /^(?=.*[a-zA-Z].*)(?=.*\d+.*)(?=.*[!@#\$%\^\&*\)\(+=._-].*).*$/g,
                                    message: "Password should have a special character, a number, and a letter"
                                }
                            })} />
                            <ErrorMessage errors={errorsCPass} name="newPassword"
                                render={({ message }) => <p className="text-danger">{message}</p>} />
                            Repeat New Password
                            <input autoComplete="off" type="password" className="form-control" {...regCPass("repeatPassword", {
                                required: "This field is required",
                                validate: (val) => {
                                    if (watch("newPassword") != val) {
                                        return "Password and Confirm Password does not match";
                                    }
                                } })} />
                            <ErrorMessage errors={errorsCPass} name="repeatPassword"
                                render={({ message }) => <p className="text-danger">{message}</p>} />
                            <button type="submit" className="d-none">submit</button>
                        </form> :
                            <form onSubmit={handleSubmit(processData)}>
                                Login ID
                                <input autoComplete="off" className="form-control" {...register("username", {required: "This field is required"})} />
                                <ErrorMessage errors={errorsLogin} name="username"
                                    render={({ message }) => <p className="text-danger">{message}</p>} />
                                Password
                                <input autoComplete="off" type="password" className="form-control" {...register("password", { required: "This field is required" })} />
                                <ErrorMessage errors={errorsLogin} name="password"
                                    render={({ message }) => <p className="text-danger">{message}</p>} />
                                <button type="submit" className="d-none">submit</button>
                            </form>
                    }
                </div>
        }
        footer={
            loading ? null :
                <div>
                    <button onClick={resetMode ? handleSubmitCPass(processData):handleSubmit(processData)}>{resetMode ? "Change Password" : "Login"}</button>
                </div>
        }
    />
}

export default AuthBox;